import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useController, useFormContext, } from 'react-hook-form';
import { clsx } from 'clsx';
import FormLabel from '@enquiryForm/components/FormLabel';
import FormGroup from '@enquiryForm/components/FormGroup';
import FormError from '@enquiryForm/components/FormError';
import { useCallback } from 'react';
function NumberInput(props) {
    const { inputAttrs, labelAttrs, className: wrapperForwardedClassName, ...wrapperAttrs } = props;
    const { name, className: forwardedInputClasses } = inputAttrs;
    const { control } = useFormContext();
    const { field: { onChange, value }, fieldState: { invalid, isTouched, error }, } = useController({
        name,
        control,
    });
    const inputClassName = clsx(['form__control'], forwardedInputClasses, { invalid: invalid && isTouched });
    // const removeAppendages = (rawValue: string) => {
    //   let newRawValue = rawValue;
    //
    //   if (inputAttrs.prefix) {
    //     newRawValue = rawValue.replace(inputAttrs.prefix, '');
    //   }
    //
    //   if (inputAttrs.suffix) {
    //     newRawValue = newRawValue.replace(inputAttrs.suffix, '');
    //   }
    //
    //   return newRawValue;
    // };
    const handleChange = useCallback((e) => {
        const target = e.target;
        const { min, max } = inputAttrs;
        let newValue = parseInt(`${target.value}`, 10) ?? 0;
        // checking if undefined in case the min is 0
        if (min !== undefined) {
            const minNumber = parseInt(`${min}`, 10);
            newValue = Math.max(minNumber, newValue);
        }
        // checking if undefined in case the max is 0 - very unlikely edge case
        if (max !== undefined) {
            const maxNumber = parseInt(`${max}`, 10);
            newValue = Math.min(maxNumber, newValue);
        }
        target.value = `${newValue}`;
        onChange(e);
    }, [onChange, inputAttrs]);
    /**
     * Has an extra hidden input, because a standard form submit post will take the currency input value which has commas
     * so is not parsed as a number by JSON.Parse for further down in the flow.
     */
    return (_jsxs(FormGroup, { className: `${error ? 'form__group--error' : ''} ${wrapperForwardedClassName}`, ...wrapperAttrs, children: [_jsx(FormLabel, { ...labelAttrs }), _jsx("input", { ...inputAttrs, name: name, value: value, onChange: handleChange, className: inputClassName }), error && (_jsx(FormError, { children: error?.message }))] }));
}
export default NumberInput;
